const LOOP_OVERVIEW_QUERY_KEY_SEGMENT = 'loop-overview';

export const isLoopOverviewQueryKey = (queryKey: ReadonlyArray<unknown>) =>
  queryKey[0] === 'objectives' && queryKey[2] === LOOP_OVERVIEW_QUERY_KEY_SEGMENT;

export const objectivesQueryKeys = {
  all: (orgId: string) => ['objectives', orgId] as const,
  byId: (orgId: string, objectiveId: number | undefined) =>
    ['objectives', orgId, objectiveId ?? 'none'] as const,
  list: {
    infinite: (orgId: string) => ['objectives', orgId, 'infinite'] as const,
    infiniteByLoopId: (orgId: string, loopId: number) =>
      ['objectives', orgId, 'infinite', { loopId }] as const,
  },
  loopOverview: {
    all: (orgId: string) => ['objectives', orgId, LOOP_OVERVIEW_QUERY_KEY_SEGMENT] as const,
    byLoopId: (orgId: string, loopId: number) =>
      [...objectivesQueryKeys.loopOverview.all(orgId), loopId] as const,
  },
  okrService: {
    all: (orgId: string) => ['objectives', orgId, 'okr-service'] as const,
    list: (orgId: string, loopId: number, includeArchived: boolean) =>
      [...objectivesQueryKeys.okrService.all(orgId), 'list', loopId, { includeArchived }] as const,
    keyResults: (orgId: string, objectiveId: number) =>
      [...objectivesQueryKeys.okrService.all(orgId), 'key-results', objectiveId] as const,
    keyResultItems: (orgId: string, keyResultId: number) =>
      [...objectivesQueryKeys.okrService.all(orgId), 'key-result-items', keyResultId] as const,
  },
  keyResults: {
    byObjectiveId: (orgId: string, objectiveId: number) =>
      ['objectives', orgId, objectiveId, 'key-results'] as const,
  },
  withKeyResults: {
    all: (orgId: string) => ['objectives', orgId, 'with-key-results'] as const,
  },
  itemObjectives: {
    byObjectiveId: (orgId: string, objectiveId: number) =>
      ['objectives', orgId, objectiveId, 'item-objectives'] as const,
  },
  linkItems: {
    all: (orgId: string) => ['objectives', orgId, 'link-items'] as const,
    ancestors: (orgId: string, itemIds: Array<number>) =>
      [...objectivesQueryKeys.linkItems.all(orgId), 'ancestors', itemIds] as const,
  },
};
